const Certificates = () => {
    return (
        <section id="certificates">
            <h2>Certificates</h2>
            <div className="project">
                <h3>AZ - 900</h3>
                <p>I have completed this certificate on July - 2024</p>
            </div>
            <div className="project">
                <h3>AWS Solution Architect</h3>
                <p>I have completed this certificate on Nov - 2024</p>
            </div>
            <div className="project">
                <h3>AWS Developer Associate</h3>
                <p>I have completed this certificate on March - 2025</p>
            </div>
        </section>
    )
}

export default Certificates;